<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> سوخت خالص مصرفی خودروها </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- فیلتر جستجو -->

    <form class="row gx-2 gy-3" [formGroup]="mdl_Search">

        <!-- از تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> از تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input type="text" formControlName="strSDate" placeholder="از تاریخ" class="form-control text-end" />

            </ng-persian-datepicker>

        </div>

        <!-- تا تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> تا تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input formControlName="strEDate" placeholder="از تاریخ" class="form-control text-end" />

            </ng-persian-datepicker>

        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-primary w-100" (click)="search_Result()">

                جستجو

            </button>

        </div>

        <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-success w-100" (click)="exportExcel('Export_Excel')">

                خروجی اکسل

            </button>

        </div>

    </form>

    <!-- جدول اطلاعات -->

    <div class="border border-2 mt-3 p-2">

        <div class="row gx-0 gy-2 gy-md-0">

            <div class="col-12">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm
                    (keyup)="filter_list($event.target)">

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 235px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <tr class="">

                        <th class="text-center col-1"> # </th>

                        <th class="text-center col-1"> نام راننده </th>

                        <th class="text-center"> نوع خودرو </th>

                        <th class="text-center"> گروه خودرویی </th>

                        <th class="text-center"> حوزه خدمت </th>

                        <th class="text-center"> نام خودرو </th>

                        <th class="text-center"> شماره شاسی </th>

                        <th class="text-center"> پلاک </th>

                        <th class="text-center"> مقدار سوختگیری </th>

                        <th class="text-center"> مقدار برداشت مشکوک </th>

                        <th class="text-center"> موجودی باک </th>

                        <th class="text-center"> مصرف </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Result;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td [innerHTML]="highlightText(item.strFullName,searchTerm.value)"> </td>

                        <td [innerHTML]="highlightText(item.strMobileType_strComment,searchTerm.value)  | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strMobileGroup_strComment,searchTerm.value)  | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strMobileDomain_strComment,searchTerm.value)  | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strGPSType_strComment,searchTerm.value)  | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strVIN,searchTerm.value)  | faNum"> </td>

                        <th> {{ item.strVehicleNo | faNum }} </th>

                        <th> {{ item.TotalRefueling?.toLocaleString() | faNum }} </th>

                        <th> {{ item.TotalHarvesting?.toLocaleString() | faNum }} </th>

                        <th> {{ item.EndTankValue?.toLocaleString() | faNum }} </th>

                        <th> {{ item.RealConsumption?.toLocaleString() | faNum }} </th>

                    </tr>

                </tbody>

                <tfoot>
                    <tr class="col-12 text-center table-total-row bg-light-2">
                        <th colspan="X"> مجموع </th>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>{{ total_TotalRefueling.toFixed(2) | faNum }}</td>
                        <td>{{ total_TotalHarvesting.toFixed(2) | faNum }}</td>
                        <td></td>
                        <td>{{ total_RealConsumption.toFixed(2) | faNum }}</td>
                    </tr>

                </tfoot>

            </table>

        </div>

    </div>

</main>